import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import Table from 'components/Table'
import AnimatedLogo from '@wellbeingxltd/fe-lib/images/dist/logo/AnimatedLogo.gif'
import { useSupplierProfile } from 'hooks/useSupplierProfile'
import { AnalyticsActions } from 'store/models/analytics'
import ResourcesActions from 'store/models/resources'
import SupplierActions from 'store/models/supplier'
import TransactionsActions from 'store/models/transactions'
import { getColumnsData } from './columnsData'
import './styles.scss'

const Directory = () => {
    const dispatch = useDispatch()
    const { isShopifyConnected, loadingGetShopifyProducts, shopifyProducts, shopifyProductsError, supplierId } = useSupplierProfile()
    const { loadingTransactions, transactionsError } = useSelector(GET_STORE.TRANSACTIONS)
    const { resources, parsedProductsWithShopifyData } = useSelector(GET_STORE.RESOURCES)

    useEffect(() => {
        document.title = 'Directory | Betterspace Supplier'
        dispatch(AnalyticsActions.postAnalytics('[Directory] componentDidMount', null))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (supplierId) {
            dispatch(TransactionsActions.getTransactions(supplierId))
            dispatch(SupplierActions.getShopifyProducts(supplierId))
        }
    }, [dispatch, supplierId])

    useEffect(() => {
        dispatch(ResourcesActions.parseProductsWithShopifyData(resources, shopifyProducts))
    }, [dispatch, resources, shopifyProducts])

    const dataToShow = isShopifyConnected ? parsedProductsWithShopifyData : resources

    if (loadingTransactions || loadingGetShopifyProducts) {
        return (
            <div className="centerLoader">
                <img src={AnimatedLogo} width="128px" alt="Full screen loading spinner" />
            </div>
        )
    }

    if (transactionsError) return <p className="error">{transactionsError}</p>

    return (
        <>
            <h1>Directory</h1>
            <Table
                data={dataToShow}
                columns={getColumnsData(shopifyProductsError)}
                emptyStateText="No resources were found. The Betterspace team will be adding your resources shortly."
            />
        </>
    )
}

export default Directory
